import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { Link } from 'react-router-dom';

export type PauseModalViewProps = {
  currentState: 'PAUSED' | 'UNPAUSED';
  onClose: (confirm: boolean) => void;
  onPause: () => void;
};

export const PauseModalView = ({ currentState, onClose, onPause }: PauseModalViewProps): JSX.Element => {
  const publishActionTitle = currentState === 'UNPAUSED' ? 'Pause All Publishing' : 'Unpause All Publishing';
  const message =
    currentState === 'UNPAUSED'
      ? 'When you pause all publishing, no Posts will be published until you unpause it. All Queued Posts will be remain dormant, but your manually-scheduled Posts will fail to publish.'
      : 'When you unpause all publishing, Posts will resume their regular publishing schedule.';

  return (
    <Modal
      title={publishActionTitle}
      onClose={() => onClose(false)}
      showCloseIcon={true}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonTitle={publishActionTitle}
      primaryButtonAction={() => {
        onClose(true);
        onPause();
      }}>
      <>
        <p>{message}</p>
        <p>
          You can also go for more granular <Link to={'/settings/pause'}>pause settings</Link>.
        </p>
      </>
    </Modal>
  );
};
